import { InfoPage } from '@/components/info-page';
import { useSession } from '@/auth/useSession';
import { isEdgeCoach } from '@airreading/common';
import { CoachProfileForm } from './coach-profile-form';
import { ProfileFormProps } from './profile-form';
import { CoachPaymentForm } from './coach-payment-form';

export const CoachPage = (props: ProfileFormProps) => {
  const { actingUser } = useSession();
  return (
    <InfoPage headerText="Account">
      <CoachProfileForm {...props} />
      {actingUser && !isEdgeCoach(actingUser) && <CoachPaymentForm />}
    </InfoPage>
  );
};
